import { Controller } from '@stimulus/core'

export default class ScrapeJobProgressController extends Controller {
    progress = 0
    started = false
    wasQueued = false

    connect() {
        const fill = document.getElementById('progress-fill')
        const text = document.getElementById('progress-text')

        if (!fill || !text) {
            console.warn('Progress elements not found')
        }

        const updateProgress = (value) => {
            this.progress = Math.min(value, 100)
            fill.style.width = `${this.progress}%`
            text.textContent = `${Math.floor(this.progress)}% voltooid`
        }

        const animateFakeProgress = () => {
            if (this.progress < 95) {
                updateProgress(this.progress + Math.random() * 2)
                setTimeout(animateFakeProgress, 1000)
            }
        }

        const pollStatus = () => {
            fetch(window.location.href)
                .then(res => res.text())
                .then(html => {
                    const isStillScraping = html.includes('class="scraping-alert"')
                    const isWorking = html.includes('Scraping is gestart')
                    const isQueued = html.includes('Scraping in de wachtrij')

                    if (!isStillScraping) {
                        updateProgress(100)
                        setTimeout(() => window.location.reload(), 500)
                        return
                    }

                    if (this.wasQueued && isWorking) {
                        window.location.reload()
                        return
                    }

                    this.wasQueued = isQueued

                    if (isWorking && !this.started) {
                        this.started = true
                        animateFakeProgress()
                    }

                    setTimeout(pollStatus, 5000)
                })
                .catch(err => {
                    console.error('Error when polling scraping status:', err)
                    setTimeout(pollStatus, 5000)
                })
        }

        pollStatus()
    }
}
